import { FC } from "react";
import { Link } from "@mui/material";

type Props = {
  children: React.ReactNode;
  href: string;
};

export const FooterLink: FC<Props> = ({ children, href }) => (
  <Link
    sx={[
      { textDecoration: "none", color: "inherit" },
      {
        "&:hover": {
          color: "#444444",
          textDecoration: "underline",
        },
      },
    ]}
    href={href}
    target="_blank"
  >
    {children}
  </Link>
);
